// extracted by mini-css-extract-plugin
module.exports = {"content":"_app_content__C3i1S"};